function addClassToBody() {
    document.body.classList.add('toggle-sidebar');
  }
  
  function removeClassFromBody() {
    document.body.classList.remove('toggle-sidebar');
  }
  
  export { addClassToBody, removeClassFromBody };